var GOOGLE_MAPS_API_KEY = "AIzaSyAJdkGCNO6QZV4_b0b651RV47-_KUhLpvs";

exports.GOOGLE_MAPS_API_KEY = GOOGLE_MAPS_API_KEY;
